// US phone formatting helpers.
// Accepts anything the user types; strips non-digits; formats for display.
// Leading "1" (country code) is preserved and prefixed with "+1".

export function formatUSPhone(value) {
  if (!value) return "";
  const digits = String(value).replace(/\D/g, "");
  if (digits.length === 0) return "";

  // Strip leading US country code if present — display as NANP only.
  const nanp = digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : digits;

  if (nanp.length < 4) return `(${nanp}`;
  if (nanp.length < 7) return `(${nanp.slice(0, 3)}) ${nanp.slice(3)}`;
  if (nanp.length <= 10) return `(${nanp.slice(0, 3)}) ${nanp.slice(3, 6)}-${nanp.slice(6, 10)}`;
  // Overflow (14+ digits) — show a clean NANP plus the extra as extension.
  return `(${nanp.slice(0, 3)}) ${nanp.slice(3, 6)}-${nanp.slice(6, 10)} x${nanp.slice(10)}`;
}

// Returns a tel: URI safe for click-to-dial. Uses E.164 when we have 10 or 11
// digits; otherwise returns whatever digits we have so the OS dialer can still
// handle it. Returns null when there's nothing dialable.
export function telHref(value) {
  if (!value) return null;
  const raw = String(value).replace(/[^\d+]/g, "");
  const digits = raw.replace(/\D/g, "");
  if (!digits) return null;
  if (digits.length === 10) return `tel:+1${digits}`;
  if (digits.length === 11 && digits.startsWith("1")) return `tel:+${digits}`;
  // Already E.164 (with +) → use as-is.
  if (raw.startsWith("+")) return `tel:${raw}`;
  return `tel:${digits}`;
}
